<!-- Rebate Request - Measurement Committee - View Valid Granted Rebate -->
<div *ngIf="!isRequestSucceeded">
    <ng-container *ngIf="!isReviewRebateComponent">
        <h2 *ngIf="!isDefineRebateAdmin" class="sectionTitle">{{this.FormTitle}}</h2>
        <app-circular-request *ngIf="!isDefineRebateAdmin" #CircularRequest
            (rebateRequestLoadedFlag)="onRebateRequestLoadedFlag($event)"></app-circular-request>
         <div *ngIf="getRelatedRequestsObjects.length > 0" class="read-only-content">

            <div class="form-container">
                <h4 class="section-title">Related Requests</h4>
            </div>

            <div class="table-responsive">
                <table class="table table-bordered table-striped table-services">
                    <thead>
                        <tr>
                            <th><span>Rebate File Number</span></th>
                            <th><span>Request Number</span></th>
                            <th><span>Service</span></th>
                            <th><span>Request Status</span></th>
                            <th><span>Decision feedback Date</span></th>
                            <th><span>Direction</span></th>
                            <th><span>Last Transit Date</span></th>
                            <th><span></span></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let relatedRequest of getRelatedRequestsObjects; let i = index;">
                            <td>{{relatedRequest.RebateFileNumber}}</td>
                            <td>{{relatedRequest.RequestNumber}}</td>
                            <td>{{relatedRequest.serviceName}}</td>
                            <td>{{relatedRequest.Status}}</td>
                            <td>{{relatedRequest.DecisionDate}}</td>
                            <td>{{relatedRequest.SailDirection}}</td>
                            <td>{{relatedRequest.LastTransitDateString}}</td>
                            <td><a class="btn" (click)="relatedRequestDetails(i)">Details</a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div [class.read-only-content]="formMode == 3 || formMode == 4">
            <form name="AdminDecisionForm" [formGroup]="AdminDecisionForm">
                <div class="form-container" #StepDecision>
                    <div class="form-section">
                        <h4 class="section-title">{{this.DecisionTitle}}</h4>
                        <div class="form-group">
                            <div class="custom-Radio">
                                <input type="radio" formControlName="ActionType" id="rbtnDecisionIdAccept" value="1"
                                    (change)="onDecisionChange()" />
                                <label for="rbtnDecisionIdAccept">Accept</label>
                            </div>
                            <div class="custom-Radio">
                                <input type="radio" formControlName="ActionType" id="rbtnDecisionIdRequireModification"
                                    value="2" (change)="onDecisionChange()" />
                                <label for="rbtnDecisionIdRequireModification">Require Modification</label>
                            </div>
                            <div class="custom-Radio">
                                <input type="radio" formControlName="ActionType" id="rbtnDecisionIdReject" value="3"
                                    (change)="onDecisionChange()" />
                                <label for="rbtnDecisionIdReject">Reject</label>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Accept Section -->
                <div *ngIf="isAccept">
                    <div class="form-container">
                        <div class="form-section">
                            <!--  <h4 class="section-title">Accept</h4>-->
                            <div class="form-section">
                                <div class="form-group">
                                    <label for="CircularsLookupId">Requested Circular</label>
                                    <select formControlName="CircularsLookupId" class="form-control"
                                        id="CircularsLookupId" name="CircularsLookupId">
                                        <option *ngFor="let circular of circulars" [value]="circular?.Id">
                                            {{circular?.CircularNo}} - {{circular?.Symbol}}
                                        </option>
                                    </select>

                                </div>
                                <div class="form-group">
                                    <label for="txtSCNT">Vessel Number (SCID)</label>
                                <input type="text" formControlName="SCID" name="SCID" id="txtSCID"
                                    class="form-control" />
                                </div>
                                <div class="form-group">
                                    <label for="txtExNames">Ex Name(s)</label>
                                    <input type="text" formControlName="ExNames" name="ExNames" id="txtExNames"
                                        class="form-control" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <label for="ddlOptions">Options</label>
                    <div formArrayName="Options">
                        <div *ngFor="let Option of AdminDecisionForm.get('Options')['controls']; let i=index; let last = last"
                            [formGroupName]="i">
                            <div class="form-container">
                                <div *ngIf="isAccept" class="form-section read-only-content">
                                    <!--  <h4 class="section-title">Accept</h4>-->


                                   <!--  <div class="form-group">
                                    <label for="ddlOptions">Options</label>

                                    <select class="form-control" disabled id="ddlOptions"
                                        formControlName="CircularsFixedRebateOptionsId" name="Options">
                                        <option  [value]="Option.get(CircularsFixedRebateOptionsId)" selected>
                                            Option {{i + 1}} ({{lastPortOriginsArr[i].Text}} -
                                            {{firstPortDestinationsArr[i].Text}})
                                        </option>
                                    </select>
                                </div> -->
                                    <div class="form-group">
                                        <label for="CircularsFixedRebateOptionNameFrom">From </label>
                                        <textarea type="text"  formControlName="CircularsFixedRebateOptionNameFrom"
                                            id="CircularsFixedRebateOptionNameFrom" name="CircularsFixedRebateOptionNameFrom"
                                            class="form-control"
                                            value="#Option{{i + 1}} {{OriginsArrPorts[i].Text}} - {{OriginsArrCountries[i].Text}} - {{OriginsArr[i].Text}} ">
                                        </textarea>
                                    </div>

                                    <div class="form-group">
                                        <label for="CircularsFixedRebateOptionNameTo">To </label>
                                        <textarea type="text"   formControlName="CircularsFixedRebateOptionNameTo"
                                            id="CircularsFixedRebateOptionNameTo" name="CircularsFixedRebateOptionNameTo"
                                            class="form-control"
                                            value="#Option {{i + 1}} {{DestinationsArrPorts[i].Text}} - {{DestinationsArrCountries[i].Text}} - {{DestinationsArr[i].Text}} ">
                                        </textarea>
                                    </div>


                                    <div class="form-group">
                                        <label for="ddlPercentages">Percentages</label>
                                        <select  class="form-control" id="ddlPercentages"
                                            formControlName="CircularsPercentagesId" name="Percentages" >

                                            <option  *ngFor="let percentages of Percentages; let i = index;"
                                                [value]="percentages?.Id"  >
                                                {{percentages.PercentageValue}} % <span></span>
                                            </option>
                                        </select>

                                    </div>

                                    <div class="form-group">
                                        <label for="isGranted"></label>
                                        <label>Grant Rebate</label>
                                        <span class="red"> *</span>
                                        <div>
                                            <div class="custom-Radio">
                                                <input type="radio" formControlName="isGranted"  id="{{ 'Yes' + i}}" [value]="true" />
                                                <label for="{{ 'Yes' + i}}">Yes</label>
                                            </div>
                                            <div class="custom-Radio">
                                                <input type="radio"  formControlName="isGranted" id="{{ 'No' + i}}"  [value]="false"  />
                                                <label for="{{ 'No' + i}}">No</label>
                                            </div>
                                        </div>

                                        <div *ngIf=" isFormSubmitted  && Option.get('isGranted')?.invalid"
                                        class="red ">
                                        <div *ngIf="Option.get('isGranted')?.errors?.required">
                                            {{'FRONT_USER.This_Field_Is_Required' | translate}}
                                        </div>
                                    </div>
                                   <!--  <div class="custom-checkbox">
                                            <input type="checkbox" formControlName="isGranted"
                                                    name="isGranted" id="isGranted"
                                                    [checked]="isGranted">
                                                    <label
                                                    for="isGranted">Grant Rebate

                                                  </label>

                                           <div *ngIf="isTabTwoSubmitted &&
                                                circularRequestForm?.controls['TabTwo']?.controls['TermsConditions']?.invalid"
                                                class="red">
                                                <span *ngIf="circularRequestForm?.controls['TabTwo']?.controls['TermsConditions']?.errors?.pattern">You
                                                    should accept Service Terms & Conditions to use this Service</span>
                                            </div>
                                    </div>-->
                                    </div>
                                    <div class="form-group">
                                        <label for="Notes">Notes</label>
                                        <textarea formControlName="Notes" id="Notes" name="Notes"
                                            class="form-control"></textarea>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="isSecondStep" class="form-group">
                        <div class="custom-Radio">
                            <input type="radio" formControlName="SecondStep_WFaction" id="rbtnDecisionIdProceed" value="1" />
                            <label for="rbtnDecisionIdProceed">Procced To Checker</label>
                        </div>
                        <div class="custom-Radio">
                            <input type="radio" formControlName="SecondStep_WFaction" id="rbtnDecisionIdSendToAgent" value="2"/>
                            <label for="rbtnDecisionIdSendToAgent">Send To Agent</label>
                        </div>
                        <div *ngIf="isFormSubmitted && f.SecondStep_WFaction?.errors" class="red">
                            <div *ngIf="f.SecondStep_WFaction?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                        </div>
                    </div>

                </div>


                <div class="form-container">
                    <div *ngIf="isRequireModification" class="form-section">
                        <h4 class="section-title">Require Modification</h4>
                        <!-- Comment -->
                        <div class="form-group">
                            <label for="txtRequireModificationNotesAndComments">Comment</label>
                            <span class="red"> *</span>
                            <textarea formControlName="RequireModificationNotesAndComments"
                                id="txtRequireModificationNotesAndComments" name="RequireModificationNotesAndComments"
                                class="form-control"></textarea>
                            <div *ngIf="isFormSubmitted &&
                                AdminDecisionForm?.controls['RequireModificationNotesAndComments']?.invalid"
                                class="red">
                                <span *ngIf="AdminDecisionForm?.controls['RequireModificationNotesAndComments']?.errors?.required">
                                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <!-- Reject Section -->
                    <div *ngIf="isReject" class="form-section">
                        <h4 class="section-title">Reject</h4>
                        <!-- Rejection Reason -->
                        <div class="form-group">
                            <label for="txtRejectionReason">Rejection Reason</label>
                            <span class="red"> *</span>
                            <textarea formControlName="RejectionReason" id="txtRejectionReason" name="RejectionReason"
                                class="form-control"></textarea>
                            <div *ngIf="isFormSubmitted && AdminDecisionForm?.controls['RejectionReason']?.invalid"
                                class="red">
                                <span *ngIf="AdminDecisionForm?.controls['RejectionReason']?.errors?.required">
                                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="formMode == FormMode.Add"  class="form-group">
                    <button type="button" class="btn SCAcustomBtn" Confirmation
                        (confirmationClick)="submit()">Submit</button>
                    <button type="button" class="btn SCAcustomBtn" (click)="later()">Later</button>
                </div>
            </form>
        </div>
    </ng-container>
</div>
<!-- Confirmation -->
<div *ngIf="isRequestSucceeded && submitConfirmationMode == 1" class="alert alert-success" role="alert">
    <div class="alignC">
        <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g>
                <g>
                    <path
                        d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
                    </path>
                </g>
            </g>
        </svg>
        <p>You have submitted Rebate Request Decision Successfully</p>
        <p *ngIf="(submitMeasurementCommitteeDecisionResponseObject.Data != null && this.isFirstStep)">Rebate File Number
            [{{submitMeasurementCommitteeDecisionResponseObject.Data}}]</p>
        <p>Go Back to <a routerLink="/CircularsTasksDirectory">Circulars Tasks</a></p>
    </div>
</div>
<!-- Warning -->
<div *ngIf="isRequestSucceeded && submitConfirmationMode == 2" class="alert alert-warning" role="alert">
    <div class="alignC">
        <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g>
                <g>
                    <path
                        d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
                    </path>
                </g>
            </g>
        </svg>
        <p>This task was submitted before</p>
        <p>Go Back to <a routerLink="/CircularsTasksDirectory">My Tasks</a></p>
    </div>
</div>
<!-- Error -->
<div *ngIf="isRequestSucceeded && submitConfirmationMode == 3" class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>Something went wrong, Please contact System Administrator</p>
        <hr>
        <p>Go Back to <a routerLink="/workspace">Workspace</a></p>
    </div>
</div>
